import * as Constants from '../constants/salesforce-import';

const initialState = {
  activeSalesforceImport: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_SALESFORCE_IMPORT_SUCCESS:
      return {
        ...state,
        activeSalesforceImport: action.payload,
      };
    case Constants.SET_SALESFORCE_IMPORT:
      return {
        ...state,
        activeSalesforceImport: action.payload,
      };
    default:
      return state;
  }
};
